<script lang="ts" setup>
withDefaults(
  defineProps<{
    titleTag?: 'h2' | 'h3'
    titleAccordionTag?: 'p' | 'h2' | 'h3'
  }>(),
  {
    titleTag: 'h2',
    titleAccordionTag: 'h2',
  },
);
</script>

<template>
  <IadWrapper inner-classes="py-xl">
    <IadTitle
      :text="$t(`agent.commitments.title`)"
      :tag="titleTag"
    />
    <div class="lg:w-1/2">
      <IadAccordion
        name="agent-commitments"
        :title="$t('agent.commitments.local_expertise.title')"
        :content="$t('agent.commitments.local_expertise.description')"
        :title-tag="titleAccordionTag"
      />
      <IadAccordion
        name="agent-commitments"
        :title="$t('agent.commitments.availability.title')"
        :content="$t('agent.commitments.availability.description')"
        :title-tag="titleAccordionTag"
      />
      <IadAccordion
        name="agent-commitments"
        :title="$t('agent.commitments.service_and_price.title')"
        :content="$t('agent.commitments.service_and_price.description')"
        :title-tag="titleAccordionTag"
      />
    </div>
  </IadWrapper>
</template>
